// extracted by mini-css-extract-plugin
export default {"not-found-box":"ErrorPage_not-found-box__mXqUI","tit":"ErrorPage_tit__k8hnp","txt1":"ErrorPage_txt1__V5V0t","txt2":"ErrorPage_txt2__IaJE9","link":"ErrorPage_link__EAzI-"};